// modules
export const FETCH_MODULES = "FETCH_MODULES";
export const FETCH_MODULES_ITEM = "FETCH_MODULES_ITEM";
export const FETCH_NEW_COURSES = "FETCH_NEW_COURSES";

// courses
export const GET_LIST = "GET_LIST";
export const GET_COURSE_ITEM = "GET_COURSE_ITEM";
export const GET_CATEGORIES = "GET_CATEGORIES";

export const GET_TIMETABLE = "GET_TIMETABLE";

export const GET_COMPONENTS = "GET_COMPONENTS";
export const GET_FILE = "GET_FILE";

export const GET_SEARCH = "GET_SEARCH";
export const SET_SEARCH_HISTORY = "SET_SEARCH_HISTORY";
export const GET_SEARCH_HISTORY = "GET_SEARCH_HISTORY";

export const UPDATE_VIDEO_SETTINGS = "UPDATE_VIDEO_SETTINGS";

// lesson
export const FETCH_LESSON = "FETCH_LESSON";
export const UPDATE_PROGRESS_LESSON = "UPDATE_PROGRESS_LESSON";
export const UPDATE_STATISTIC_LESSON = "UPDATE_STATISTIC_LESSON";
export const CREATE_LESSON_RATE = "CREATE_LESSON_RATE";
export const UPDATE_LESSON_RATE = "UPDATE_LESSON_RATE";
export const UPDATE_LESSON_RATE_COMMENT = "UPDATE_LESSON_RATE_COMMENT";
export const SET_LESSON_FAVOURITE = "SET_LESSON_FAVOURITE";
export const SET_LESSON_UNFAVOURITE = "SET_LESSON_UNFAVOURITE";

// materials
export const FETCH_MATERIALS = "FETCH_MATERIALS";
export const FETCH_MATERIALS_ITEM = "FETCH_MATERIALS_ITEM";

// events
export const FETCH_EVENTS = "FETCH_EVENTS";
export const FETCH_EVENTS_ITEM = "FETCH_EVENTS_ITEM";

// streams
export const FETCH_STREAMS = "FETCH_STREAMS";
export const FETCH_STREAMS_ITEM = "FETCH_STREAMS_ITEM";

// home work
export const GET_HOME_WORK = "GET_HOME_WORK";
export const SEND_ANSWER = "SEND_ANSWER";

export const COMPLETE_QUESTION = "COMPLETE_QUESTION";
export const COMPLETE_TEST = "COMPLETE_TEST";
export const GET_LIST_ITEM = "GET_LIST_ITEM";
export const GET_REPORT = "GET_REPORT";
export const START_TEST = "START_TEST";
export const SEND_COMMENT = "SEND_COMMENT";
export const SEND_COMMENT_FILE = "SEND_COMMENT_FILE";
export const CREATE_RATE = "CREATE_RATE";
export const UPDATE_RATE = "UPDATE_RATE";
export const UPDATE_RATE_COMMENT = "UPDATE_RATE_COMMENT";

//widgets
export const FETCH_STUDENTS_LIST = "FETCH_STUDENTS_LIST";

//feedback
export const SEND_FEEDBACK_FORM = "SEND_FEEDBACK_FORM";
export const GET_FEEDBACK_FORM = "GET_FEEDBACK_FORM";
